import React, { useState, useEffect } from "react";
import { Box, Typography } from "@material-ui/core";
import { IntroText, CheckboxList, FormActionDrawer } from "../../../components";
import { useHeader } from "../../../contexts";
import {
  formatApiValuesFromCheckboxList,
  formatCheckboxListFromApiValues
} from "../../../utils";
import { useTranslation } from "react-i18next";

const OptionsData = [
  {
    value: "bars_restaurants_cafes",
    label_translation_key:
      "schedule.public_places.options.bars_restaurants_cafes"
  },
  {
    value: "gas_stations",
    label_translation_key: "schedule.public_places.options.gas_stations"
  },
  {
    value: "medical_offices",
    label_translation_key: "schedule.public_places.options.medical_offices"
  },
  {
    value: "place_of_work",
    label_translation_key: "schedule.public_places.options.place_of_work"
  },
  {
    value: "retail_grocery_stores",
    label_translation_key: "schedule.public_places.options.retail_grocery_stores"
  },
  {
    value: "places_of_worship",
    label_translation_key: "schedule.public_places.options.places_of_worship"
  },
  {
    value: "public_parks",
    label_translation_key: "schedule.public_places.options.public_parks"
  },
  {
    value: "other",
    label_translation_key: "schedule.public_places.options.other"
  },
  {
    value: "none",
    label_translation_key: "schedule.public_places.options.none"
  }
];

const SchedulePublicPlaces = ({
  setDrawerClearance,
  updateScheduleData,
  scheduleData,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();
  const [publicPlaces, setPublicPlaces] = useState();
  const [error, setError] = useState(false);

  useEffect(() => {
    setTitle(t("schedule.public_places.title"));
  }, []);

  const handleNext = () => {
    if (publicPlaces.length > 0) {
      updateScheduleData({
        publicPlaces: formatApiValuesFromCheckboxList(OptionsData, publicPlaces)
      });
    } else {
      setError(true);
    }
  };

  return (
    <Box data-cy="schedule-screen-public-places">
      <IntroText>{t("schedule.public_places.intro_text")}</IntroText>
      {error && (
        <Typography data-cy="schedule-screen-public-places-error" color="error">
          {t("schedule.public_places.error")}
        </Typography>
      )}
      {OptionsData.length > 0 && (
        <CheckboxList
          allowMultiple
          options={OptionsData}
          onChange={setPublicPlaces}
          initialValues={formatCheckboxListFromApiValues(
            scheduleData.publicPlaces
          )}
        />
      )}
      <FormActionDrawer
        setDrawerClearance={setDrawerClearance}
        handleNext={e => handleNext()}
        loading={isSubmitting}
      />
    </Box>
  );
};

export { SchedulePublicPlaces };
